import React, { useEffect, useRef, useState } from "react";
import socket from "../lib/socket";

function choiceEmoji(choice) {
  if (choice === "rock") return "🪨";
  if (choice === "paper") return "📄";
  if (choice === "scissors") return "✂️";
  return "🎮";
}

export default function RpsOverlayLayer({ room = "" }) {
  const [result, setResult] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    function onResult(payload = {}) {
      if (!payload?.id) return;
      setResult(payload);
      window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setResult(null), 7600);
    }
    socket.on("rps:result", onResult);
    return () => {
      socket.off("rps:result", onResult);
      window.clearTimeout(timerRef.current);
    };
  }, [room]);

  if (!result) return null;

  const tied = result.outcome === "tie";
  const winner = result.winner;
  const loser = result.loser;

  return (
    <div
      aria-live="polite"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 23,
        pointerEvents: "none",
        display: "grid",
        placeItems: "center",
        padding: "7%",
      }}
    >
      <style>
        {"@keyframes gaEmbeddedRps { 0% { opacity: 0; transform: scale(.72) rotate(-2deg); } 10% { opacity: 1; transform: scale(1.04) rotate(0); } 18%, 82% { opacity: 1; transform: scale(1); } 100% { opacity: 0; transform: scale(.9) translateY(-16px); } }"}
      </style>
      <div
        key={result.id + ":" + result.ts}
        style={{
          width: "min(720px, 86%)",
          padding: "clamp(15px, 2.6vw, 30px)",
          borderRadius: 24,
          border: "2px solid rgba(255,255,255,.34)",
          background:
            "radial-gradient(circle at 50% 0%, rgba(70,150,255,.24), transparent 52%), linear-gradient(135deg, rgba(8,12,24,.97), rgba(78,0,26,.96))",
          boxShadow: "0 24px 70px rgba(0,0,0,.74)",
          color: "white",
          textAlign: "center",
          animation: "gaEmbeddedRps 7.5s ease both",
        }}
      >
        <div
          style={{
            fontSize: "clamp(13px, 1.6vw, 22px)",
            textTransform: "uppercase",
            letterSpacing: 1.5,
            fontWeight: 1000,
            color: tied ? "#d9e5ff" : "#ffd65c",
          }}
        >
          {tied ? "RPS Stalemate" : "RPS Winner"}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            alignItems: "center",
            gap: "clamp(8px, 2vw, 22px)",
            marginTop: 12,
          }}
        >
          <div>
            <div style={{ fontSize: "clamp(34px, 6vw, 82px)" }}>
              {result.choiceAEmoji || choiceEmoji(result.choiceA)}
            </div>
            <div style={{ fontWeight: 1000, fontSize: "clamp(13px, 2vw, 26px)" }}>
              {result.playerA?.name || "Player 1"}
            </div>
            <div style={{ opacity: 0.76, marginTop: 3 }}>
              Record {result.aRecord || "0-0"}
            </div>
          </div>
          <div
            style={{
              fontWeight: 1000,
              fontSize: "clamp(18px, 3vw, 42px)",
              color: "#ff6f7f",
            }}
          >
            VS
          </div>
          <div>
            <div style={{ fontSize: "clamp(34px, 6vw, 82px)" }}>
              {result.choiceBEmoji || choiceEmoji(result.choiceB)}
            </div>
            <div style={{ fontWeight: 1000, fontSize: "clamp(13px, 2vw, 26px)" }}>
              {result.playerB?.name || "Player 2"}
            </div>
            <div style={{ opacity: 0.76, marginTop: 3 }}>
              Record {result.bRecord || "0-0"}
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 14,
            fontSize: "clamp(16px, 2.5vw, 34px)",
            fontWeight: 1000,
            color: tied ? "white" : "#9dffb8",
          }}
        >
          {tied
            ? "Both players locked the same pick"
            : (winner?.name || "Winner") +
              " defeated " +
              (loser?.name || "their opponent")}
        </div>
        {!tied && Number(result.gasPointsAwarded || 0) > 0 ? (
          <div
            style={{
              display: "inline-block",
              marginTop: 9,
              padding: "7px 13px",
              borderRadius: 999,
              background: "rgba(255,193,7,.15)",
              border: "1px solid rgba(255,214,92,.42)",
              color: "#ffd65c",
              fontWeight: 1000,
              fontSize: "clamp(12px, 1.5vw, 20px)",
            }}
          >
            +{Number(result.gasPointsAwarded).toLocaleString()} GAS Points
          </div>
        ) : null}
      </div>
    </div>
  );
}

